<template>
    <div class="eq-footer">
        <slot></slot>
    </div>
</template>
<script lang="ts" setup></script>
